import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import FileManagementModal from './FileManagementModal'

const VariableFileEditButton = ({
  resourceId,
  ensembleId,
  resourceName,
  ensembleName,
  variable,
  value = null
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const hasFile = value?.file?.filename

  return (
    <>
      <i
        className="fas fa-edit ml-2 c-pointer"
        title={hasFile ? 'Modifier le fichier' : 'Ajouter un fichier'}
        onClick={handleClick}
      />
      <FileManagementModal
        resourceId={resourceId}
        ensembleId={ensembleId}
        resourceName={resourceName}
        ensembleName={ensembleName}
        variableIds={[variable.id]}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  )
}

VariableFileEditButton.propTypes = {
  ensembleId: PropTypes.number.isRequired,
  ensembleName: PropTypes.string.isRequired,
  resourceId: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
  variable: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
}

export default VariableFileEditButton